import {GU_FAILURE, GU_PENDING, GU_SUCCESS, GSU_SUCCESS, GSUE_SUCCESS} from './constants'

const initialState = {
  users: null,
  userEmails: null,
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GU_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case GU_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        users: action.payload,
        userEmails: action.payload,
      }
    case GSU_SUCCESS:
      state.users = [...state.users, ...action.payload]
      return {
        ...state,
      }
    case GSUE_SUCCESS:
      state.userEmails = [...state.userEmails, ...action.payload]
      return {
        ...state,
      }
    case GU_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
